import Modal from "../ui-components/Modal";
import Toggle from "../ui-components/Toggle";
import Button from "../ui-components/Button";
import {FormattedMessage, useIntl} from "react-intl";
import {useState} from "react";
import Textarea from "../ui-components/Textarea";

const TCSDialog = ({
                       setShowTCSDialog,
                       notes,
                       setNotes,
                       flgGdpr,
                       flgMarketing,
                       setFlgGdpr,
                       setFlgMarketing,
                       sendToTCS
                   }) => {
    const intl = useIntl()

    return (<Modal onExit={() => {
        setShowTCSDialog(false)
    }}>
        <div className="mb-6">
            <Toggle
                vertical
                label={intl.formatMessage({id: "consent_gdpr"})}
                checked={flgGdpr}
                onChange={() => setFlgGdpr(!flgGdpr)}
            />
            <Toggle
                vertical
                label={intl.formatMessage({id: "consent_marketing"})}
                checked={flgMarketing}
                onChange={() => setFlgMarketing(!flgMarketing)}
            />
            <Textarea
                label={<FormattedMessage id="notes"/>}
                value = {notes}
                onChange = {(e) => setNotes(e.target.value)}
            />
        </div>
        <Button onClick={sendToTCS} disabled={!flgGdpr}>
            <FormattedMessage id="confirm"/>
        </Button>

    </Modal>)
}

export default TCSDialog